import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=9c95ab5c&scoped=true&"
import script from "./Layout.vue?vue&type=script&lang=js&"
export * from "./Layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c95ab5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/olaei/OneDrive/Documents/GitHub/demoside/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VBtn,VFlex,VForm,VLayout,VTextField,VTextarea})
